import DataWrapperChart from 'components/DataWrapperChart'
import React from 'react'
import styled from 'styled-components'
import './styles.scss'

import category from '../category.json'
const Wrapper = styled.div`
  position: relative;
`

const CategoryList = styled.div`
  font-family: var(--chart-font-stack);
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 626px;
  padding: 5px 0px;
  flex-wrap: nowrap;
  justify-content: center;
  margin: 15px auto 30px auto;
  @media (max-width: 600px) {
    margin: 15px auto 15px auto;
    position: sticky;
    top: 0;
  }
`

const CategorySelector = styled.div`
  padding: 5px 0px;
  margin: 0px 0px;
  min-width: 120px;
  font-size: 0.8em;
  text-align: center;
  cursor: pointer;
  &:hover {
    background-color: ${props => (props.selected ? '#202346' : '#c8c8d1')};
    color: ${props => (props.selected ? '#fff' : '#202346')};
    border-color: ${props =>
      props.selected ? '1px solid #202346' : '1px solid #C8C8D1'};
  }
  font-weight: ${props => (props.selected ? '600' : '300')};
  color: ${props => (props.selected ? '#fff' : '#c8c8d1')};
  background-color: ${props => (props.selected ? '#202346' : undefined)};
  border: ${props =>
    props.selected ? '1px solid #202346' : '1px solid #C8C8D1'};
  margin-top: -1px;
`

const BarChartList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
`

function BarChartSelector() {
  const [selected, setSelected] = React.useState('Spitaleintritte')

  const currentCategory = category.find(c => c.category === selected)
  const currentTitle = category.find(c => c.category === selected)

  return (
    <Wrapper>
      {/* <div className='titleBox noBorder'> */}

      {/* <div className='graphicSub'>
          Wählen Sie eine Kategorie aus, um die kantonale Landnutzung zu sehen.
        </div> */}
      {/* </div> */}
      <h4 className='graphicTitle'>
        Impfdurchbrüche nach Impfstofftyp pro 100'000 Personen
      </h4>
      <CategoryList>
        <BarChartList>
          {category
            // .filter(f => f.animal === 'no')
            .map((c, index) => (
              <>
                <CategorySelector
                  dangerouslySetInnerHTML={{ __html: c.category }}
                  selected={c.category === selected}
                  onClick={() => setSelected(c.category)}
                  key={index}
                  className={
                    (index === 0 ? 'firstElement' : '') +
                    (index !== 0 ? 'notFirstElement' : '') +
                    (index === 2 ? ' lastElement' : '')
                  }
                >
                  {/* {c.category} */}
                </CategorySelector>
              </>
            ))}
        </BarChartList>
      </CategoryList>
      {currentCategory && <DataWrapperChart chartId={currentCategory.dw_map} />}
    </Wrapper>
  )
}

export default BarChartSelector
